import React from 'react';
import { StringColumn, CustomColumn, NumericalColumn } from 'baseui/data-table';
import { Button, KIND, SIZE } from 'baseui/button';
import { useStyletron } from 'baseui';

import { CustomDateColumn, EMPTY_STRING, EMPTY_ARRAY, EMPTY_NUMBER } from 'commons-ui';
import downloadImg from 'commons-ui/src/assets/misc/download.png';

export const COL_NAMES = {
	agentId: 'agentId',
	agentReply: 'agentReply',
	ticketStatus: 'ticketStatus',
	createdBy: 'createdBy',
	createdAt: 'createdAt',
	requestStatus: 'requestStatus',
	ticketsCount: 'ticketsCount',
	processedTicketsCount: 'processedTicketsCount',
	ticketsUpdateFailedInfo: 'ticketsUpdateFailedInfo'
};

const CSV_COLUMNS_NAME = ['ticketId', 'error'];

const downloadCsvFile = (data: any) => {
	const csvString = [
		CSV_COLUMNS_NAME,
		...(data || EMPTY_ARRAY).map((item: any) => [item.ticketId, JSON.stringify(item.error).toString().replaceAll(',', ' || ')])
	]
		.map((e) => e.join(','))
		.join('\n');
	const csvContent = `data:text/csv;charset=utf-8, ${csvString}`;
	const encodedUri = encodeURI(csvContent);

	const link = document.createElement('a');
	link.setAttribute('href', encodedUri);
	link.setAttribute('download', `updateTicketsFailedDetails-${Math.ceil(Math.random() * 10)}.csv`);
	document.body.appendChild(link);
	link.click();
};

export const columnConfigs = [
	NumericalColumn({
		title: 'Agent Id',
		mapDataToValue: (data: any) => data[COL_NAMES.agentId] || EMPTY_NUMBER
	}),
	CustomColumn({
		title: 'Agent Reply',
		minWidth: 300,
		maxWidth: 400,
		mapDataToValue: (data: any) => data[COL_NAMES.agentReply] || EMPTY_STRING,
		renderCell: (params: any) => {
			const { value } = params;
			let agentReplyCompress = '';
			if (value.length > 50) {
				agentReplyCompress = `${value.substr(0, 50)}...`;
			} else {
				agentReplyCompress = value;
			}
			return <div title={value}>{agentReplyCompress}</div>;
		}
	}),
	StringColumn({
		title: 'Ticket Status',
		mapDataToValue: (data: any) => data[COL_NAMES.ticketStatus] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Created By',
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdAt
	}),
	NumericalColumn({
		title: 'Tickets Count',
		mapDataToValue: (data: any) => data[COL_NAMES.ticketsCount] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Processed Tickets Count',
		mapDataToValue: (data: any) => data[COL_NAMES.processedTicketsCount] || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Request Processed Status',
		mapDataToValue: (data: any) => data[COL_NAMES.requestStatus] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Tickets Update Failed Count',
		maxWidth: 200,
		minWidth: 100,
		mapDataToValue: (data: any) => data[COL_NAMES.ticketsUpdateFailedInfo],
		renderCell: (params: any) => {
			const { value } = params;
			const failedTicketCount: number = value.length || EMPTY_NUMBER;
			return <div>{failedTicketCount}</div>;
		}
	}),
	CustomColumn({
		title: 'Tickets Update Failed Info.',
		maxWidth: 200,
		minWidth: 100,
		mapDataToValue: (data: any) => {
			return {
				ticketsUpdateFailedInfo: data[COL_NAMES.ticketsUpdateFailedInfo],
				processedTicketsCount: data[COL_NAMES.processedTicketsCount],
				ticketsCount: data[COL_NAMES.ticketsCount]
			};
		},
		renderCell: (params: any) => {
			const { value } = params;
			const { ticketsUpdateFailedInfo, processedTicketsCount, ticketsCount } = value;
			const failedTicketsCount: number = ticketsUpdateFailedInfo.length;
			const [css] = useStyletron();

			return failedTicketsCount > 0 && processedTicketsCount === ticketsCount ? (
				<Button
					size={SIZE.mini}
					kind={KIND.tertiary}
					onClick={() => {
						downloadCsvFile(ticketsUpdateFailedInfo);
					}}
					overrides={{
						Root: {
							style: () => ({
								height: '100%',
								width: '100%',
								fontSize: '12px',
								fontWeight: 'normal'
							})
						}
					}}>
					<img className={css({ height: '20px', width: '20px' })} src={downloadImg} alt='download' />
				</Button>
			) : (
				<div />
			);
		}
	})
];
